export default __webpack_public_path__ + "static/media/car-crash.f9d719f2.png";